<div class="btn-group-toggle" *ngFor="let option of options">
  <label class="btn h-100 d-flex align-items-center justify-content-center text-break"
         [class.checked]="isChecked(option)"
         [class.disabled]="disabled"
         [class.readonly]="readonly">
    <input [type]="inputType"
           [name]="name"
           [readonly]="readonly"
           [disabled]="disabled"
           [checked]="isChecked(option)"
           (change)="fireCheck(!isChecked(option), option.id)">
    <span [class.text-danger]="blocksConfig.localizable
                               && !option.localizedName(currentContentLocale, originalContentLocale)
                               && !(option.settings.name.length === 0)">
      {{ option.localizedName(currentContentLocale, originalContentLocale, true) || ('blocks.' + blockType + '.new_option' | transloco) }}
    </span>
  </label>
</div>
